import { render, staticRenderFns } from "./SettlementIndexModal.vue?vue&type=template&id=2da72746&scoped=true&"
import script from "./SettlementIndexModal.vue?vue&type=script&lang=js&"
export * from "./SettlementIndexModal.vue?vue&type=script&lang=js&"
import style0 from "./SettlementIndexModal.vue?vue&type=style&index=0&id=2da72746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da72746",
  null
  
)

export default component.exports